export const CashComponent = {
    template: `
        <p class="checkout-spacing">{{$ctrl.paymentService.data.cashPayment.body}}</p>
    `,
    controller: class {
        constructor(paymentService) {
            'ngInject';
            this.paymentService = paymentService;
        }
    }
};
